module.exports = __webpack_public_path__ + "img/haim_katz_neeman_2.b5659ab7.jpg";